import { compressSync, decompressSync, strFromU8, strToU8 } from "fflate";
import {
  addDoc,
  arrayUnion,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase.config";
import { normaliseCodingSets, parsePlayerPositions } from "./pstsFile";

export async function fetchTranslations(language, page) {
  try {
    const eRef = collection(db, "translations");
    const q = query(
      eRef,
      where("language", "==", language),
      where("page", "==", page)
    );
    const querySnap = await getDocs(q);
    const trs = [];
    querySnap.forEach((doc) => {
      return trs.push(doc.data());
    });
    var tr = null;
    if (trs.length > 0) {
      tr = trs[0];
    }
  } catch (error) {
    console.log(error);
  }
  return tr;
}

export async function fetchAllTranslations() {
  try {
    const eRef = collection(db, "translations");
    const q = query(eRef);
    const querySnap = await getDocs(q);
    const trs = [];
    querySnap.forEach((doc) => {
      return trs.push(doc.data());
    });
    return trs;
  } catch (error) {
    console.log(error);
    return [];
  }
}

export async function fetchAllTranslationsForLanguage(lang) {
  try {
    const eRef = collection(db, "translations");
    const q = query(eRef, where("language", "==", lang));
    const querySnap = await getDocs(q);
    const trs = [];
    querySnap.forEach((doc) => {
      return trs.push(doc.data());
    });
    return trs;
  } catch (error) {
    console.log(error);
    return [];
  }
}

export async function updateTranslations(tr) {
  try {
    if (!tr.uid || tr.uid.length === 0) {
      const doc = await addDoc(collection(db, "translations"), tr);
      tr.uid = doc.id;
    }
    await setDoc(doc(db, "translations", tr.uid), tr);
    return { translation: tr, error: "" };
  } catch (error) {
    console.log(error.message);
    return { translation: null, error: error.message };
  }
}

export async function fetchAllLanguages() {
  const trs = await fetchAllTranslations();
  var langs = {};
  var xlangs = [];
  for (var tr of trs) {
    if (langs[tr.language] === undefined) {
      langs[tr.language] = tr.language;
      xlangs.push(tr.language);
    }
  }
  return xlangs.sort((a, b) => a - b);
}

export async function fetchUser(userUid) {
  try {
    const eRef = collection(db, "users");
    const q = query(eRef, where("userUid", "==", userUid));
    const querySnap = await getDocs(q);
    const usrs = [];
    querySnap.forEach((doc) => {
      return usrs.push(doc.data());
    });
    var usr = null;
    if (usrs.length > 0) {
      usr = usrs[0];
    }
  } catch (error) {
    console.log(error);
  }
  return usr;
}

export async function fetchUserByEmail(email) {
  try {
    const eRef = collection(db, "users");
    const q = query(eRef, where("email", "==", email));
    const querySnap = await getDocs(q);
    const usrs = [];
    querySnap.forEach((doc) => {
      return usrs.push(doc.data());
    });
    var usr = null;
    if (usrs.length > 0) {
      usr = usrs[0];
    }
  } catch (error) {
    console.log(error);
  }
  return usr;
}
  
export async function updateUser(u) {
  try {
    var uu = await fetchUser(u.userUid);
    if (!uu) {
      const x = await addDoc(collection(db, "users"), u);
      u.userUid = x.id;
        await setDoc(doc(db, "users", u.userUid), u);
      return { user: u, error: "" };
    }
    else
    {
      await setDoc(doc(db, "users", u.userUid), u);
      return { user: u, error: "" };  
    }
  } catch (error) {
    console.log(error.message);
    return { user: null, error: error.message };
  }
}

function compressSets(sets) {
  const json = JSON.stringify(sets);
  const compressed = compressSync(strToU8(json));
  let binary = "";
  for (let i = 0; i < compressed.length; i++) {
    binary += String.fromCharCode(compressed[i]);
  }
  return btoa(binary);
}

function decompressSets(b64) {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return JSON.parse(strFromU8(decompressSync(bytes)));
}

export async function fetchMatchData(uid, matchdataid) {
  if (!uid) return null;
  try {
    const docRef = doc(db, "users", uid, "matchdata", matchdataid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) return docSnap.data();
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function fetchMatchByGuid(uid, guid) {
  if (!uid) return null;
  try {
    const docRef = doc(db, "users", uid, "matches", guid);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) return null;
    return { ...docSnap.data(), firestoreId: docSnap.id };
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function fetchMatchWithData(uid, guid) {
  if (!uid) return null;
  try {
    const match = await fetchMatchByGuid(uid, guid);
    if (match) {
      if (match.matchdataid) {
        const md = await fetchMatchData(uid, match.matchdataid);
        match.sets = md?.compressedSets ? decompressSets(md.compressedSets) : (md?.sets ?? []);
      } else {
        match.sets = [];
      }
      if (match.isDoubles) applyPlayerPositions(match);
      return reconcileEventPlayers(normaliseMatchSets(match));
    }
    // Not in the user's own collection → maybe it was shared with them.
    return await fetchSharedMatchByGuid(uid, guid);
  } catch (error) {
    console.log(error);
    return null;
  }
}

// Doubles-only: expands each event's raw `playerPositions` string into
// `serveFormation`/`returnFormation`/`netPosition` columns (see
// pstsFile.js's parsePlayerPositions for the format) — imported PSTS events
// already get this in getEvent, but events coded directly in-app only ever
// wrote the raw string, so it's backfilled here on every read instead.
function applyPlayerPositions(match) {
  for (const s of match.sets ?? []) {
    for (const e of s?.events ?? []) {
      if (e?.playerPositions) Object.assign(e, parsePlayerPositions(e.playerPositions));
    }
  }
}

// Matches coded in-app store their sets in the live "coding" event format:
// `scores` is an object, ball positions are `{x, y}`, and there is no
// `playerGuid`/`startBall`/`eventString`. Reports and analysis screens instead
// consume the PSTS/DB event format (`scores` as a "set:set game:game" string,
// `startBall`/`endBall` as "x,y" strings, etc.). When coding-format events are
// detected, convert the sets in place — preserving each event's real video
// time and re-sorting into chronological order — so downstream consumers always
// see the shape (and ordering) they expect.
function normaliseMatchSets(match) {
  if (!match) return match;
  const sets = match.sets ?? [];
  const isCodingFormat = sets.some((s) =>
    (s?.events ?? []).some((e) => e && typeof e.scores !== "string"),
  );
  if (!isCodingFormat) return match;
  try {
    match.sets = normaliseCodingSets(match);
  } catch (error) {
    console.log("normaliseMatchSets failed:", error?.message);
  }
  return match;
}

// Reconcile every event's player identity with the match's current players.
// After a player merge (or other corruption) the stored events can reference a
// stale/orphaned GUID, and the match's player OBJECTS can disagree with its
// GUID fields — which misattributes stats (StatsObject compares
// `e.player.guid` to `match.player1.guid`). We rebuild canonical players from
// the match fields (kept current by merges), sync the match objects to them,
// then attribute each event by the most reliable signal available: player name
// (survives GUID corruption), then a distinct current GUID, then `playerNo`.
function reconcileEventPlayers(match) {
  if (!match || match.isDoubles) return match; // singles only
  const nameKey = (fn, ln) =>
    `${(fn ?? "").trim().toLowerCase()}|${(ln ?? "").trim().toLowerCase()}`;

  const p1 = {
    guid: match.player1Guid ?? match.player1?.guid ?? "",
    firstName: match.player1FirstName ?? match.player1?.firstName ?? "",
    lastName: match.player1LastName ?? match.player1?.lastName ?? "",
    country: match.player1?.country ?? {
      code: match.player1CountryCode ?? "",
      name: "",
    },
  };
  const p2 = {
    guid: match.player2Guid ?? match.player2?.guid ?? "",
    firstName: match.player2FirstName ?? match.player2?.firstName ?? "",
    lastName: match.player2LastName ?? match.player2?.lastName ?? "",
    country: match.player2?.country ?? {
      code: match.player2CountryCode ?? "",
      name: "",
    },
  };
  if (!p1.guid && !p2.guid && !p1.lastName && !p2.lastName) return match;

  // Keep the match's player objects consistent with the fields.
  match.player1 = { ...(match.player1 ?? {}), ...p1 };
  match.player2 = { ...(match.player2 ?? {}), ...p2 };

  const n1 = nameKey(p1.firstName, p1.lastName);
  const n2 = nameKey(p2.firstName, p2.lastName);
  const distinctNames = n1 && n2 && n1 !== n2;
  const distinctGuids = p1.guid && p2.guid && p1.guid !== p2.guid;

  for (const s of match.sets ?? []) {
    for (const e of s?.events ?? []) {
      if (!e) continue;
      const evName = nameKey(e.player?.firstName, e.player?.lastName);
      const evGuid = e.player?.guid ?? e.playerGuid;
      let target = null;
      if (distinctNames) {
        if (evName === n1) target = p1;
        else if (evName === n2) target = p2;
      }
      if (!target && distinctGuids) {
        if (evGuid === p1.guid) target = p1;
        else if (evGuid === p2.guid) target = p2;
      }
      if (!target) target = Number(e.playerNo) === 1 ? p2 : p1;
      e.player = {
        ...(e.player ?? {}),
        guid: target.guid,
        firstName: target.firstName,
        lastName: target.lastName,
        country: target.country,
      };
      e.playerGuid = target.guid;
      e.playerNo = target === p1 ? 0 : 1;
      e.isPlayer1 = target === p1;
    }
  }
  return match;
}

// Finds a match shared with this user (or shared with everyone) by guid and
// returns it fully hydrated (with sets) from the self-contained shared copy.
async function fetchSharedMatchByGuid(uid, guid) {
  try {
    const snap = await getDocs(
      query(collection(db, "sharedMatches"), where("guid", "==", guid)),
    );
    if (snap.empty) return null;
    // Multiple sharedMatches docs can exist for the same guid (re-shares by
    // different owners, or stale/legacy duplicates) — security rules only
    // ever return docs this user is allowed to read, but among those, always
    // prefer the most recently updated one instead of an arbitrary one
    // (Firestore doesn't guarantee query result ordering), or a fresh edit
    // can be silently shadowed by an older duplicate.
    let best = null;
    snap.forEach((d) => {
      const data = d.data();
      if (!best || (data.updatedAt ?? 0) > (best.data.updatedAt ?? 0)) {
        best = { d, data };
      }
    });
    if (snap.size > 1) {
      console.log(
        `fetchSharedMatchByGuid: ${snap.size} shared copies found for guid=${guid}, using most recently updated (docId=${best.d.id})`,
      );
    }
    const { data } = best;
    const m = { ...(data.match ?? {}) };
    m.sets = data.compressedSets
      ? decompressSets(data.compressedSets)
      : (data.sets ?? []);
    m.shared = true;
    m.ownerUid = data.ownerUid;
    m.sharedBy = data.ownerEmail ?? "";
    m.sharedPlaylists = data.sharedPlaylists ?? [];
    return reconcileEventPlayers(normaliseMatchSets(m));
  } catch (error) {
    console.log(error.message);
  }
  return null;
}

export async function saveMatch(match, uid) {
  const effectiveUid = uid ?? match.uid;
  if (!effectiveUid) return { match: null, error: "No uid" };
  try {
    // Strip any share-copy-only bookkeeping fields (present if `match` ever
    // originated from a fetched shared copy) — this must always persist as
    // the OWNER's own authoritative data, never a stale recipient view of it.
    const { sets, firestoreId, shared, ownerUid, sharedBy, sharedPlaylists, ...matchWithoutSets } = match;
    const matchdataid = match.guid;
    const compressedSets = compressSets(sets ?? []);
    await setDoc(doc(db, "users", effectiveUid, "matchdata", matchdataid), { compressedSets, guid: matchdataid });
    await setDoc(doc(db, "users", effectiveUid, "matches", match.guid), { ...matchWithoutSets, matchdataid, uid: effectiveUid });
    // Keep this owner's own shared copy (if any) in sync — otherwise anyone
    // the match was shared with keeps seeing a stale snapshot from whenever
    // it was first shared, even after the owner corrects/edits events.
    await refreshOwnSharedCopy(effectiveUid, match.guid, matchWithoutSets, compressedSets);
    return { match, error: "" };
  } catch (error) {
    console.log(error.message);
    return { match: null, error: error.message };
  }
}

// Refreshes the `match`/`compressedSets` fields of this owner's OWN
// sharedMatches doc(s) (if they've shared this match), so recipients always
// see the latest coded data instead of a stale snapshot from share time —
// leaves shareStatus/shareUsers/shareEmails/sharedPlaylists/etc untouched.
// Looks up by the `guid`+`ownerUid` FIELDS (a query) rather than assuming the
// doc id is exactly `${uid}_${guid}` — the id is normally built that way (see
// updateMatchShare), but querying by field is robust to any historical/
// legacy doc-id mismatch, and naturally supports more than one matching doc.
// A no-op if this owner has never shared this match, and it only ever
// touches docs owned by THIS uid, never anyone else's re-share of the match.
async function refreshOwnSharedCopy(uid, guid, matchWithoutSets, compressedSets) {
  try {
    const snap = await getDocs(
      query(collection(db, "sharedMatches"), where("guid", "==", guid)),
    );
    const updates = [];
    snap.forEach((d) => {
      const data = d.data();
      if (data.ownerUid !== uid) return; // not this owner's own share entry
      updates.push(
        updateDoc(doc(db, "sharedMatches", d.id), {
          match: matchWithoutSets,
          compressedSets,
          updatedAt: Date.now(),
        }),
      );
    });
    if (updates.length === 0) {
      console.log(`refreshOwnSharedCopy: no shared copy found for uid=${uid} guid=${guid}`);
      return;
    }
    await Promise.all(updates);
    console.log(`refreshOwnSharedCopy: refreshed ${updates.length} shared copy doc(s) for guid=${guid}`);
  } catch (error) {
    console.log("refreshOwnSharedCopy failed:", error.message);
  }
}

export async function updateMatchVideoFile(uid, guid, videoFile) {
  if (!uid) return;
  try {
    await updateDoc(doc(db, "users", uid, "matches", guid), { videoFile });
  } catch (error) {
    console.log(error);
  }
}

// Gathers a lightweight snapshot of this user's own Playlists that reference
// this match's events, for bundling into a share (see updateMatchShare's
// `includePlaylists`). Only items whose eventKey belongs to this match (the
// key format is `${matchGuid}:${videoPos}:${setNumber}`, see makeEventKey in
// VideoAnalysis.jsx) are included — a playlist normally mixes clips from many
// matches, so it isn't shared/copied wholesale, just the relevant items.
async function collectSharedPlaylists(uid, guid) {
  try {
    const playlists = await fetchUserPlaylists(uid);
    const prefix = `${guid}:`;
    const out = [];
    for (const pl of playlists) {
      const eventKeys = pl.eventKeys ?? {};
      const matchingIdx = Object.entries(eventKeys).filter(
        ([, key]) => typeof key === "string" && key.startsWith(prefix),
      );
      if (matchingIdx.length === 0) continue;
      const filteredEventKeys = {};
      const filteredComments = {};
      for (const [idx, key] of matchingIdx) {
        filteredEventKeys[idx] = key;
        if (pl.comments?.[idx]) filteredComments[idx] = pl.comments[idx];
      }
      out.push({
        name: pl.name ?? "",
        itemCount: matchingIdx.length,
        eventKeys: filteredEventKeys,
        comments: filteredComments,
      });
    }
    return out;
  } catch (error) {
    console.log(error.message);
    return [];
  }
}

// Share a match with other users.
//   shareStatus: 0 = not shared, 2 = selected users (1/"everyone" is retired —
//                matches can now only ever be shared with specific accounts)
//   shareUsers:  comma-separated list of user emails (used when shareStatus === 2)
//   includePlaylists: when true, this user's own Playlists (clips + comments)
//                      built from this match's events are bundled into the
//                      share as `sharedPlaylists`; when false that field is
//                      cleared, so recipients see a clean copy of the match.
// `match` must be the FULL match object (including `sets`) so a self-contained
// copy can be written to the top-level `sharedMatches` collection that
// recipients query — matches themselves live under the owner's uid and are not
// directly readable by other users.
// Re-sharing: `match` may itself be a match SHARED WITH the current user
// (`match.shared === true`, from fetchMatchWithData's shared-copy fallback) —
// in that case the current uid doesn't own a `users/{uid}/matches/{guid}` doc
// for it, so step 1 below is skipped, and this re-share is recorded as its own
// independent `sharedMatches/{uid}_{guid}` entry alongside the original
// sharer's (never modifying or replacing it).
export async function updateMatchShare(uid, match, shareData) {
  if (!uid || !match?.guid) return { error: "No uid/match" };
  try {
    const guid = match.guid;
    // Coerce the retired "everyone" tier (1) to "selected users" defensively —
    // the UI no longer offers it, but never persist it if somehow received.
    let shareStatus = shareData?.shareStatus ?? 0;
    if (shareStatus === 1) shareStatus = 2;
    const shareUsers = shareData?.shareUsers ?? "";
    const shareEmails =
      shareStatus === 2 && shareUsers
        ? shareUsers
            .split(",")
            .map((e) => e.trim().toLowerCase())
            .filter(Boolean)
        : [];

    // 1. Flags on the owner's own match doc (drives the owner's "Shared"
    // filter) — only applicable when this uid actually owns the match; a
    // re-share of a match shared WITH this uid has no such doc to update.
    if (!match.shared) {
      await updateDoc(doc(db, "users", uid, "matches", guid), {
        shareStatus,
        shareUsers,
        shareEmails,
      });
    }

    // 2. Maintain the top-level shared copy that recipients can read.
    const sharedRef = doc(db, "sharedMatches", `${uid}_${guid}`);
    if (shareStatus === 0) {
      await deleteDoc(sharedRef).catch(() => {});
      return { error: "" };
    }

    // Capture the previously-shared emails so only newly-added recipients are
    // notified (avoids re-emailing on every save).
    let prevEmails = [];
    try {
      const prevSnap = await getDoc(sharedRef);
      if (prevSnap.exists()) prevEmails = prevSnap.data().shareEmails ?? [];
    } catch {
      /* ignore */
    }

    const { sets, firestoreId, shared, ownerUid, sharedBy, sharedPlaylists: _staleSharedPlaylists, ...matchWithoutSets } = match;
    const ownerEmail = (match.ownerEmail ?? shareData?.ownerEmail ?? "").toLowerCase();
    const compressedSets = compressSets(sets ?? []);
    const sharedPlaylists = shareData?.includePlaylists
      ? await collectSharedPlaylists(uid, guid)
      : [];
    await setDoc(sharedRef, {
      ownerUid: uid,
      ownerEmail,
      guid,
      match: matchWithoutSets,
      compressedSets,
      shareStatus,
      shareUsers,
      shareEmails, // lowercased recipient emails (selected-users mode)
      isPublic: false, // public/"everyone" sharing is retired
      sharedPlaylists,
      updatedAt: Date.now(),
    });

    // 3. Email newly-added recipients (selected-users mode). Fire-and-forget so
    // a mail failure never blocks the share itself.
    if (shareStatus === 2) {
      const newly = shareEmails.filter((e) => !prevEmails.includes(e));
      await Promise.all(
        newly.map((e) => notifyMatchShareByEmail(e, ownerEmail, matchWithoutSets)),
      ).catch(() => {});
    }
    return { error: "" };
  } catch (error) {
    console.log(error.message);
    return { error: error.message };
  }
}

// Builds a human-readable label for a match (players/teams + date).
function matchShareLabel(m) {
  const p1 = `${m.player1FirstName ?? ""} ${m.player1LastName ?? ""}`.trim();
  const p2 = `${m.player2FirstName ?? ""} ${m.player2LastName ?? ""}`.trim();
  const date = m.matchDate ? new Date(m.matchDate).toLocaleDateString() : "";
  const teams = m.isDoubles
    ? `${m.teamA?.name ?? "Team A"} vs ${m.teamB?.name ?? "Team B"}`
    : `${p1 || "Player 1"} vs ${p2 || "Player 2"}`;
  return `${teams}${date ? ` — ${date}` : ""}`;
}

function escapeHtml(s) {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

// Queues a "match shared with you" email via the Firebase "Trigger Email from
// Firestore" extension (writes to the `mail` collection). Recipients without a
// TennisStats account get a link to register.
async function notifyMatchShareByEmail(toEmail, ownerEmail, match) {
  try {
    const user = await fetchUserByEmail(toEmail);
    const registered = !!user?.userUid;
    const appUrl = "https://tennisstats.net";
    const from = ownerEmail || "A TennisStats Pro user";
    const label = matchShareLabel(match);
    const subject = `${from} shared a tennis match with you`;
    const intro = `${from} has shared the match "${label}" with you on TennisStats Pro.`;
    const cta = registered
      ? `Sign in to TennisStats Pro, open Matches and select "Shared with me" to watch it.`
      : `You don't have a TennisStats Pro account yet. Register for free to view this match.`;
    const text = `${intro}\n\n${cta}\n${appUrl}`;
    const html =
      `<p>${escapeHtml(intro)}</p>` +
      `<p>${escapeHtml(cta)}</p>` +
      `<p><a href="${appUrl}">${appUrl}</a></p>`;
    await addDoc(collection(db, "mail"), {
      to: [toEmail],
      message: { subject, text, html },
      type: "matchShare",
      registered,
      fromEmail: ownerEmail || "",
      createdAt: Date.now(),
    });
    // eslint-disable-next-line no-console
    console.log(`[matchShare] queued email to ${toEmail} (registered=${registered})`);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("[matchShare] failed to queue email to", toEmail, error);
  }
}

// Returns the matches shared with this user (by email) plus any shared with
// everyone (legacy — the "everyone" tier is retired, no NEW share ever sets
// isPublic:true, but old docs may still have it). Rows are lightweight (no
// sets); full data is fetched on demand via fetchMatchWithData (which falls
// back to the shared copy).
export async function fetchSharedMatches(email) {
  const lower = (email ?? "").trim().toLowerCase();
  if (!lower) return [];
  // Each query is awaited (and caught) independently — these used to run
  // through a single Promise.all, so if the (now-legacy, rarely used)
  // isPublic query ever failed (permission/index issue, etc.) the whole
  // Promise.all rejected and silently discarded the "shared with me by
  // email" results too, even though that query itself succeeded. That made
  // matches genuinely shared with a user appear to just not show up at all.
  const snapshots = [];
  try {
    snapshots.push(
      await getDocs(
        query(collection(db, "sharedMatches"), where("shareEmails", "array-contains", lower)),
      ),
    );
  } catch (error) {
    console.log("fetchSharedMatches (by email) failed:", error.message);
  }
  try {
    snapshots.push(
      await getDocs(query(collection(db, "sharedMatches"), where("isPublic", "==", true))),
    );
  } catch (error) {
    console.log("fetchSharedMatches (legacy public) failed:", error.message);
  }
  try {
    const seen = new Set();
    const out = [];
    for (const snap of snapshots) {
      snap.forEach((d) => {
        const data = d.data();
        if ((data.ownerEmail ?? "").toLowerCase() === lower) return; // skip own
        if (seen.has(d.id)) return;
        seen.add(d.id);
        const m = data.match ?? {};
        out.push({
          ...m,
          guid: data.guid ?? m.guid,
          shared: true,
          ownerUid: data.ownerUid,
          sharedBy: data.ownerEmail ?? "",
          sharedPlaylists: data.sharedPlaylists ?? [],
          firestoreId: d.id,
        });
      });
    }
    return out;
  } catch (error) {
    console.log(error.message);
    return [];
  }
}

export async function fetchAllMatches(uid) {
  if (!uid) return [];
  try {
    const querySnap = await getDocs(collection(db, "users", uid, "matches"));
    const ms = [];
    querySnap.forEach((d) => {
      ms.push({ ...d.data(), firestoreId: d.id });
    });
    return ms;
  } catch (error) {
    console.log(error);
    return [];
  }
}

// --- Playlists (PSPL format) ---

export async function fetchUserPlaylists(uid) {
  if (!uid) return [];
  try {
    const [ownSnap, sharedSnap] = await Promise.all([
      getDocs(query(collection(db, "playlists"), where("uid", "==", uid))),
      getDocs(query(collection(db, "playlists"), where("members", "array-contains", uid))),
    ]);
    const seen = new Set();
    const playlists = [];
    for (const snap of [ownSnap, sharedSnap]) {
      snap.forEach((d) => {
        if (!seen.has(d.id)) {
          seen.add(d.id);
          playlists.push({ firestoreId: d.id, ...d.data() });
        }
      });
    }
    playlists.sort((a, b) => (b.updatedAt ?? b.createdAt ?? 0) - (a.updatedAt ?? a.createdAt ?? 0));
    return playlists;
  } catch (error) {
    console.log(error.message);
    return [];
  }
}

export async function saveUserPlaylist(uid, playlist) {
  try {
    const now = Date.now();
    const data = {
      uid,
      name: playlist.name,
      data: playlist.data,
      items: playlist.items,
      updatedAt: now,
    };
    if (playlist.comments !== undefined) data.comments = playlist.comments;
    if (playlist.eventKeys !== undefined) data.eventKeys = playlist.eventKeys;
    // playerGuid: set when every item belongs to the same player; null clears it.
    if (playlist.playerGuid !== undefined) data.playerGuid = playlist.playerGuid;
    if (playlist.firestoreId) {
      await setDoc(doc(db, "playlists", playlist.firestoreId), data, { merge: true });
      return { firestoreId: playlist.firestoreId, error: "" };
    }
    const ref = await addDoc(collection(db, "playlists"), { ...data, createdAt: now, members: [uid] });
    return { firestoreId: ref.id, error: "" };
  } catch (error) {
    console.log(error.message);
    return { firestoreId: null, error: error.message };
  }
}

export async function addPlaylistItemComment(firestoreId, itemIdx, comment, commenterUid) {
  try {
    const now = Date.now();
    await updateDoc(doc(db, "playlists", firestoreId), {
      [`comments.${itemIdx}`]: arrayUnion(comment),
      updatedAt: now,
    });
    // Fan out notifications to all other members
    if (commenterUid) {
      const snap = await getDoc(doc(db, "playlists", firestoreId));
      if (snap.exists()) {
        const pl = snap.data();
        const members = pl.members ?? [pl.uid];
        const others = members.filter((uid) => uid !== commenterUid);
        if (others.length > 0) {
          await Promise.all(
            others.map((toUid) =>
              addDoc(collection(db, "playlistNotifications"), {
                toUid,
                playlistId: firestoreId,
                playlistName: pl.name ?? "",
                commentAuthor: comment.author ?? "",
                commentText: comment.text ?? "",
                eventIdx: itemIdx,
                createdAt: now,
                read: false,
              })
            )
          );
        }
      }
    }
    return { error: "" };
  } catch (error) {
    console.log(error.message);
    return { error: error.message };
  }
}

// --- Filter presets ---

export async function fetchUserFilterPresets(uid) {
  try {
    const snap = await getDocs(
      query(collection(db, "filterPresets"), where("uid", "==", uid))
    );
    const presets = [];
    snap.forEach((d) => presets.push({ firestoreId: d.id, ...d.data() }));
    presets.sort((a, b) => (b.createdAt ?? 0) - (a.createdAt ?? 0));
    return presets;
  } catch (error) {
    console.log(error.message);
    return [];
  }
}

export async function saveUserFilterPreset(uid, name, options) {
  try {
    const now = Date.now();
    const ref = await addDoc(collection(db, "filterPresets"), {
      uid,
      name,
      options: JSON.stringify(options),
      createdAt: now,
    });
    return { firestoreId: ref.id, error: "" };
  } catch (error) {
    console.log(error.message);
    return { firestoreId: null, error: error.message };
  }
}

export async function deleteUserFilterPreset(firestoreId) {
  try {
    const { deleteDoc } = await import("firebase/firestore");
    await deleteDoc(doc(db, "filterPresets", firestoreId));
    return { error: "" };
  } catch (error) {
    console.log(error.message);
    return { error: error.message };
  }
}

// --- Players ---

export async function fetchPlayerByGuid(uid, guid) {
  if (!uid) return null;
  try {
    const docSnap = await getDoc(doc(db, "users", uid, "players", guid));
    return docSnap.exists() ? { ...docSnap.data() } : null;
  } catch (error) {
    console.log(error.message);
    return null;
  }
}

/**
 * Creates a player record if one doesn't already exist for this guid.
 * Returns { isNew: bool, player: object }.
 */
export async function upsertPlayer(player, uid) {
  if (!player?.guid || !uid) return { isNew: false, player: null };
  try {
    const existing = await fetchPlayerByGuid(uid, player.guid);
    if (existing) return { isNew: false, player: existing };
    const data = { ...player, uid, createdAt: Date.now() };
    await setDoc(doc(db, "users", uid, "players", player.guid), data);
    return { isNew: true, player: data };
  } catch (error) {
    console.log(error.message);
    return { isNew: false, player: null };
  }
}

/**
 * Merges enrichment fields (from Wikidata etc.) into an existing player record.
 */
export async function updatePlayerEnrichment(uid, guid, enrichmentData) {
  if (!uid) return;
  try {
    await setDoc(
      doc(db, "users", uid, "players", guid),
      { ...enrichmentData, enrichedAt: Date.now() },
      { merge: true }
    );
  } catch (error) {
    console.log(error.message);
  }
}

export async function fetchAllPlayers(uid) {
  if (!uid) return [];
  try {
    const snap = await getDocs(collection(db, "users", uid, "players"));
    const ps = [];
    snap.forEach((d) => ps.push({ ...d.data() }));
    return ps;
  } catch (error) {
    console.log(error.message);
    return [];
  }
}

export async function savePlayer(player) {
  const uid = player?.uid;
  if (!uid || !player?.guid) return { error: "No uid or guid" };
  try {
    await setDoc(doc(db, "users", uid, "players", player.guid), player, { merge: true });
    return { error: "" };
  } catch (error) {
    console.log(error.message);
    return { error: error.message };
  }
}

/**
 * Deletes a match record (and its matchdata) for the given uid+guid.
 */
export async function deleteMatch(uid, guid) {
  if (!uid || !guid) return { error: "No uid or guid" };
  try {
    const { deleteDoc } = await import("firebase/firestore");
    await deleteDoc(doc(db, "users", uid, "matches", guid));
    await deleteDoc(doc(db, "users", uid, "matchdata", guid)).catch(() => {});
    return { error: "" };
  } catch (error) {
    console.log(error.message);
    return { error: error.message };
  }
}

/**
 * Rewrite the stored events of one match so any event belonging to `fromGuid`
 * now references `toGuid` (+ the target player's name). Keeps the compressed set
 * data consistent after a player merge. No-op if the match has no matchdata or
 * no matching events.
 */
async function repointMatchEvents(uid, matchdataid, fromGuid, toPlayer, toGuid) {
  if (!uid || !matchdataid) return;
  try {
    const md = await fetchMatchData(uid, matchdataid);
    const sets = md?.compressedSets
      ? decompressSets(md.compressedSets)
      : md?.sets ?? null;
    if (!sets || sets.length === 0) return;
    let changed = false;
    for (const s of sets) {
      for (const e of s?.events ?? []) {
        if (!e) continue;
        const evGuid = e.player?.guid ?? e.playerGuid;
        if (evGuid !== fromGuid) continue;
        changed = true;
        if (e.player && typeof e.player === "object") {
          e.player.guid = toGuid;
          e.player.firstName = toPlayer.firstName ?? e.player.firstName ?? "";
          e.player.lastName = toPlayer.lastName ?? e.player.lastName ?? "";
          if (toPlayer.country) e.player.country = toPlayer.country;
        }
        if ("playerGuid" in e) e.playerGuid = toGuid;
      }
    }
    if (!changed) return;
    await setDoc(doc(db, "users", uid, "matchdata", matchdataid), {
      compressedSets: compressSets(sets),
      guid: matchdataid,
    });
  } catch (error) {
    console.log("repointMatchEvents failed:", error?.message);
  }
}

/**
 * Merges `fromGuid` player into `toGuid` player across all matches.
 * - Rewrites every match that references fromGuid to use toGuid + toPlayer's names.
 * - Deletes the fromGuid player record.
 */
export async function mergePlayerRecords(uid, fromGuid, toGuid) {
  if (!uid || !fromGuid || !toGuid) return { error: "Missing arguments" };
  try {
    // Load the target player record
    const toSnap = await getDoc(doc(db, "users", uid, "players", toGuid));
    if (!toSnap.exists()) return { error: "Target player not found" };
    const toPlayer = toSnap.data();

    // Scan all matches for references to fromGuid
    const matchSnap = await getDocs(collection(db, "users", uid, "matches"));
    const updates = [];
    matchSnap.forEach((d) => {
      const m = d.data();
      const patch = {};
      if (m.player1Guid === fromGuid) {
        patch.player1Guid = toGuid;
        patch.player1FirstName = toPlayer.firstName ?? "";
        patch.player1LastName = toPlayer.lastName ?? "";
        patch.player1CountryCode = toPlayer.country?.code ?? m.player1CountryCode ?? "";
      }
      if (m.player2Guid === fromGuid) {
        patch.player2Guid = toGuid;
        patch.player2FirstName = toPlayer.firstName ?? "";
        patch.player2LastName = toPlayer.lastName ?? "";
        patch.player2CountryCode = toPlayer.country?.code ?? m.player2CountryCode ?? "";
      }
      if (Object.keys(patch).length > 0) {
        updates.push(updateDoc(doc(db, "users", uid, "matches", d.id), patch));
        // Also repoint the stored events (in the compressed set data) so their
        // player GUID/name stay consistent with the merged match — otherwise
        // the events reference the now-deleted `fromGuid` and get misattributed.
        updates.push(repointMatchEvents(uid, m.matchdataid ?? d.id, fromGuid, toPlayer, toGuid));
      }
    });
    await Promise.all(updates);

    // Delete the old player record
    const { deleteDoc } = await import("firebase/firestore");
    await deleteDoc(doc(db, "users", uid, "players", fromGuid));
    return { error: "", updatedCount: updates.length };
  } catch (error) {
    console.log(error.message);
    return { error: error.message };
  }
}

// ── Playlist sharing ──────────────────────────────────────────────────────────

/**
 * Share one playlist to one or more email addresses.
 * Creates a playlistShares doc for every recipient and ensures the owner is in the members list.
 */
export async function sharePlaylist(fromUid, fromEmail, fromName, toEmails, playlist) {
  const now = Date.now();
  try {
    // Ensure the original playlist doc tracks the owner in its members array
    if (playlist.firestoreId) {
      await updateDoc(doc(db, "playlists", playlist.firestoreId), {
        members: arrayUnion(fromUid),
      });
    }
    await Promise.all(
      toEmails.map((email) =>
        addDoc(collection(db, "playlistShares"), {
          fromUid,
          fromEmail: fromEmail ?? "",
          fromName: fromName ?? fromEmail ?? "",
          toEmail: email.toLowerCase().trim(),
          playlistName: playlist.name ?? "",
          playlistData: playlist.data ?? "",
          playlistItems: playlist.items ?? 0,
          playlistComments: playlist.comments ?? {},
          playlistFirestoreId: playlist.firestoreId ?? null,
          createdAt: now,
          status: "pending",
        })
      )
    );
    return { error: "" };
  } catch (error) {
    console.log(error.message);
    return { error: error.message };
  }
}

/**
 * Fetch share info for the playlists this user is involved in.
 * Returns:
 *   - outgoingByPlaylist: { [playlistFirestoreId]: [{ toEmail, status, createdAt }] }
 *   - incomingByPlaylist: { [playlistFirestoreId]: { fromEmail, fromName, status, createdAt } }
 */
export async function fetchPlaylistShareInfo(uid, userEmail) {
  const out = { outgoingByPlaylist: {}, incomingByPlaylist: {} };
  try {
    const tasks = [];
    if (uid) tasks.push(getDocs(query(collection(db, "playlistShares"), where("fromUid", "==", uid))));
    else tasks.push(Promise.resolve(null));
    if (userEmail) tasks.push(getDocs(query(collection(db, "playlistShares"), where("toEmail", "==", userEmail.toLowerCase()))));
    else tasks.push(Promise.resolve(null));

    const [outSnap, inSnap] = await Promise.all(tasks);

    if (outSnap) {
      outSnap.forEach((d) => {
        const s = d.data();
        const pid = s.playlistFirestoreId;
        if (!pid) return;
        if (!out.outgoingByPlaylist[pid]) out.outgoingByPlaylist[pid] = [];
        out.outgoingByPlaylist[pid].push({
          toEmail: s.toEmail,
          status: s.status,
          createdAt: s.createdAt ?? 0,
        });
      });
      // Sort each playlist's recipients by most recent
      Object.values(out.outgoingByPlaylist).forEach((arr) =>
        arr.sort((a, b) => (b.createdAt ?? 0) - (a.createdAt ?? 0))
      );
    }
    if (inSnap) {
      inSnap.forEach((d) => {
        const s = d.data();
        const pid = s.playlistFirestoreId;
        if (!pid) return;
        const prev = out.incomingByPlaylist[pid];
        if (!prev || (s.createdAt ?? 0) > (prev.createdAt ?? 0)) {
          out.incomingByPlaylist[pid] = {
            fromEmail: s.fromEmail ?? "",
            fromName: s.fromName ?? s.fromEmail ?? "",
            status: s.status,
            createdAt: s.createdAt ?? 0,
          };
        }
      });
    }
  } catch (error) {
    console.log(error.message);
  }
  return out;
}

/** Fetch all pending incoming shares for a given email address. */
export async function fetchIncomingShares(userEmail) {
  if (!userEmail) return [];
  try {
    const snap = await getDocs(
      query(
        collection(db, "playlistShares"),
        where("toEmail", "==", userEmail.toLowerCase()),
        where("status", "==", "pending")
      )
    );
    const shares = [];
    snap.forEach((d) => shares.push({ shareId: d.id, ...d.data() }));
    shares.sort((a, b) => (b.createdAt ?? 0) - (a.createdAt ?? 0));
    return shares;
  } catch (error) {
    console.log(error.message);
    return [];
  }
}

/** Accept a share — adds the recipient's UID to the original playlist's members array (linked model).
 * Falls back to creating a copy if the share doc has no playlistFirestoreId (legacy). */
export async function acceptPlaylistShare(shareId, uid, share) {
  const now = Date.now();
  try {
    if (share.playlistFirestoreId) {
      // Linked model: join the original playlist as a member
      await updateDoc(doc(db, "playlists", share.playlistFirestoreId), {
        members: arrayUnion(uid),
        updatedAt: now,
      });
      await updateDoc(doc(db, "playlistShares", shareId), {
        status: "accepted",
        acceptedAt: now,
      });
      return { firestoreId: share.playlistFirestoreId, error: "" };
    }
    // Legacy fallback: create a copy
    const playlistDoc = {
      uid,
      name: share.playlistName,
      data: share.playlistData,
      items: share.playlistItems ?? 0,
      sharedBy: share.fromEmail,
      sharedAt: share.createdAt,
      createdAt: now,
      updatedAt: now,
      members: [uid],
    };
    if (share.playlistComments && Object.keys(share.playlistComments).length > 0) {
      playlistDoc.comments = share.playlistComments;
    }
    const ref = await addDoc(collection(db, "playlists"), playlistDoc);
    await updateDoc(doc(db, "playlistShares", shareId), {
      status: "accepted",
      acceptedAt: now,
    });
    return { firestoreId: ref.id, error: "" };
  } catch (error) {
    console.log(error.message);
    return { firestoreId: null, error: error.message };
  }
}

/** Dismiss a share without adding the playlist. */
export async function dismissPlaylistShare(shareId) {
  try {
    await updateDoc(doc(db, "playlistShares", shareId), { status: "dismissed" });
    return { error: "" };
  } catch (error) {
    console.log(error.message);
    return { error: error.message };
  }
}

// --- Teams ---

export async function fetchTeamByGuid(uid, guid) {
  if (!uid) return null;
  try {
    const docSnap = await getDoc(doc(db, "users", uid, "teams", guid));
    return docSnap.exists() ? { ...docSnap.data() } : null;
  } catch (error) {
    console.log(error.message);
    return null;
  }
}

/**
 * Creates a team record if one doesn't already exist for this guid.
 * Returns { isNew: bool, team: object }.
 */
export async function upsertTeam(team, uid) {
  if (!team?.guid || !uid) return { isNew: false, team: null };
  try {
    const existing = await fetchTeamByGuid(uid, team.guid);
    if (existing) return { isNew: false, team: existing };
    const data = { ...team, uid, createdAt: Date.now() };
    await setDoc(doc(db, "users", uid, "teams", team.guid), data);
    return { isNew: true, team: data };
  } catch (error) {
    console.log(error.message);
    return { isNew: false, team: null };
  }
}

export async function fetchAllTeams(uid) {
  if (!uid) return [];
  try {
    const snap = await getDocs(collection(db, "users", uid, "teams"));
    const ts = [];
    snap.forEach((d) => ts.push({ ...d.data() }));
    return ts;
  } catch (error) {
    console.log(error.message);
    return [];
  }
}

export async function saveTeam(team) {
  const uid = team?.uid;
  if (!uid || !team?.guid) return { error: "No uid or guid" };
  try {
    await setDoc(doc(db, "users", uid, "teams", team.guid), team, { merge: true });
    return { error: "" };
  } catch (error) {
    console.log(error.message);
    return { error: error.message };
  }
}

/**
 * Merges `fromGuid` team into `toGuid` team across all doubles matches.
 * Rewrites teamA/teamB references on every affected match, then deletes the old team record.
 */
export async function mergeTeamRecords(uid, fromGuid, toGuid) {
  if (!uid || !fromGuid || !toGuid) return { error: "Missing arguments" };
  try {
    const toSnap = await getDoc(doc(db, "users", uid, "teams", toGuid));
    if (!toSnap.exists()) return { error: "Target team not found" };
    const toTeam = toSnap.data();

    const matchSnap = await getDocs(collection(db, "users", uid, "matches"));
    const updates = [];
    matchSnap.forEach((d) => {
      const m = d.data();
      if (!m.isDoubles) return;
      const patch = {};
      if (m.teamA?.guid === fromGuid) {
        patch.teamA = { ...m.teamA, guid: toGuid, name: toTeam.name ?? m.teamA.name };
      }
      if (m.teamB?.guid === fromGuid) {
        patch.teamB = { ...m.teamB, guid: toGuid, name: toTeam.name ?? m.teamB.name };
      }
      if (Object.keys(patch).length > 0) {
        updates.push(updateDoc(doc(db, "users", uid, "matches", d.id), patch));
      }
    });
    await Promise.all(updates);

    const { deleteDoc } = await import("firebase/firestore");
    await deleteDoc(doc(db, "users", uid, "teams", fromGuid));
    return { error: "", updatedCount: updates.length };
  } catch (error) {
    console.log(error.message);
    return { error: error.message };
  }
}

/** Fetch unread playlist comment notifications for a user. */
export async function fetchPlaylistNotifications(uid) {
  if (!uid) return [];
  try {
    const snap = await getDocs(
      query(
        collection(db, "playlistNotifications"),
        where("toUid", "==", uid),
        where("read", "==", false)
      )
    );
    const notifs = [];
    snap.forEach((d) => notifs.push({ notifId: d.id, ...d.data() }));
    notifs.sort((a, b) => (b.createdAt ?? 0) - (a.createdAt ?? 0));
    return notifs;
  } catch (error) {
    console.log(error.message);
    return [];
  }
}

/** Mark a list of notification docs as read. */
export async function markNotificationsRead(notifIds) {
  if (!notifIds?.length) return;
  try {
    await Promise.all(
      notifIds.map((id) => updateDoc(doc(db, "playlistNotifications", id), { read: true }))
    );
  } catch (error) {
    console.log(error.message);
  }
}
